import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { ServiceShape } from 'lib/util/productShape';
import { LinkableTextArea } from 'components/LinkableTextArea/LinkableTextArea';

import styles from './ProductDetailsView.module.css';
import { printPriceTitle } from 'lib/util/util';
import { useCurrencyFormatter } from 'hooks/useCurrencyFormatter';

type Props = { service: ServiceShape };

export const ProductServiceListItem = ({ service }: Props) => {
  const { t } = useTranslation();

  const currencyFormatter = useCurrencyFormatter();

  return (
    <li>
      <p className={styles['option__list__item__content__ttl']}>{service.name}</p>

      <div className={styles['option__list__item__content__info']}>
        {service.description && (
          <div className="c-schedule2__list__item__body__text">
            <div className="c-schedule2__list__item__body__text__th">{t('[Description]')}</div>
            <div className={clsx('c-schedule2__list__item__body__text__td', 'newline')}>
              <LinkableTextArea>{service.description}</LinkableTextArea>
            </div>
          </div>
        )}
        <div className="c-schedule2__list__item__body__price">
          <div className="c-schedule2__list__item__body__price__th">{t('[Price]')}</div>
          {service.type === 'FREE' ? (
            <div className="c-schedule2__list__item__body__price__td">{t('Free')}</div>
          ) : (
            <div className="c-schedule2__list__item__body__price__td">
              {service.pricesSummary.map((price) => (
                <p key={price.unitTitle}>
                  <span>{printPriceTitle(price, t)}</span>
                  {currencyFormatter.format(price.amount)}
                </p>
              ))}
            </div>
          )}
        </div>
      </div>
    </li>
  );
};
